module.exports = __webpack_public_path__ + "8ed0f4c795fcde3c86e4aa0eb71aff4c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/gallery/i/i29.jpg
// module id = 633
// module chunks = 0